<template>
  <v-card class="pl-6" :height="height">
    <v-container fluid>
      <v-row dense>
        <v-col cols="2">
          <date-picker label="Default date" v-model="defaultValues.Date" date-only/>
        </v-col>
        <v-col cols="4">
          <v-autocomplete v-model="defaultValues.Customer" outlined dense label="Default customer" :items="customers" item-text="name" item-value="id"/>
        </v-col>
        <v-col cols="4" v-if="sites.length>1">
          <v-autocomplete v-model="defaultValues.Site" outlined dense label="Default site" :items="sites" item-text="name" item-value="id"/>
        </v-col>
      </v-row>
      <v-row dense >
        <v-col cols="2">
          <v-autocomplete label="Default invoice type" v-model="defaultValues['Default invoice type']" :items="paymentMethods" outlined dense/>
        </v-col>
        <v-col cols="2">
          <v-autocomplete label="Default Tax" v-model="defaultValues.Tax" :items="taxes" outlined dense item-text="name" item-value="id"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="8">
          <v-text-field label="Default note" v-model="defaultValues.Note" outlined dense :rules="[fieldRules.maxLength(1000)]"/>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import {format} from 'date-fns'

export default {
  name: 'SalesShipmentsImport',
  props: {
    height: {type:String,required:true},
    defaultValues: {type:Object, required:true}
  },
  data() {
    return {
      customers: [],
      paymentMethods: [],
      taxes: []
    }
  },
  computed: {
    sites() {
      return this.$store.getters.sites(true).map(site => site.name);
    },
    connectedToAccounting() {
      return this.$store.getters.company.connectedToAccounting;
    },
  },
  async created() {
    this.defaultValues.Date = format(new Date(), 'yyyy-MM-dd');
    const paymentMethods = [];
    const data = await Promise.all([
      this.$store.dispatch('customers', true),
      this.$lazyListLoad(this.taxes, 'taxes2', 'name', 100, [{field:'active', comparator:'eq', value:'true'},{field:'salesRate', comparator:'ne', value:''}]),
      this.$lazyListLoad(paymentMethods, 'paymentMethods2', 'name', 100, [{field:'active', comparator:'eq', value:'true'}])
    ]);
    this.customers = data[0];
    this.defaultValues.Customer = this.customers[0];
    this.paymentMethods = ['None','Invoice',...paymentMethods.map(method => method.name)];
    if (this.connectedToAccounting) {
      this.defaultValues['QuickBooks sale type'] = 'None';
      this.defaultValues.Tax = this.taxes.length ? this.taxes[0] : '';
    }
    this.defaultValues.Note = 'Imported';
    this.defaultValues.Site = this.sites[0];
  },
  methods: {
  }
}
</script>